import { Route, Switch, useLocation } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import ConversationPage from "../pages/ConversationPage";
import ConversationsListPage from "../pages/ConversationsListPage";
import ExplorePage from "../pages/ExplorePage";
import HelpPage from "../pages/HelpPage";
import HomePage from "../pages/HomePage";
import BugReportConfirmationView from "./BugReportConfirmationView";
import CreateConversationView from "./CreateConversationView";
import { EventsListView } from "./EventsListView";
import NewsListView from "./NewsListView";
import NewsView from "./NewsView";
import PostView from "./PostView";
import RecentLocationWrapper from "./RecentLocationWrapper";
import SupportWidgetContainer from "./SupportWidgetContainer";

const Routes = ({ onClose }: { onClose: () => void }) => {
  const location = useLocation();

  const getPageName = () => {
    switch (location.pathname) {
      case "/":
        return "Home";
      case "/conversations":
        return "Conversations";
      case "/help":
        return t("support_widget_v2.help_page.title");
      case "/explore":
        return "Explore";
      default:
        return "Home";
    }
  };

  return (
    <SupportWidgetContainer onClose={onClose} pageName={getPageName()}>
      <RecentLocationWrapper>
        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route
            exact
            path="/conversations"
            component={ConversationsListPage}
          />
          <Route
            exact
            path="/conversations/:id"
            key="path"
            component={ConversationPage}
          />
          <Route exact path="/explore" component={ExplorePage} />

          <Route exact path="/help" component={HelpPage} />
          <Route exact path="/spaces/:spaceId/posts" component={HelpPage} />
          <Route exact path="/space_groups" component={HelpPage} />
          <Route
            exact
            path="/posts/:id"
            render={({ match }) => (
              <PostView id={match.params.id} key={match.params.id} />
            )}
          />

          <Route exact path="/news" component={NewsListView} />
          <Route exact path="/news/:id" component={NewsView} />

          <Route exact path="/events" component={EventsListView} />

          <Route
            exact
            path="/report_bug_form"
            component={CreateConversationView}
          />
          <Route
            exact
            path="/message_confirmation/:id"
            component={BugReportConfirmationView}
          />
        </Switch>
      </RecentLocationWrapper>
    </SupportWidgetContainer>
  );
};

export default Routes;
